<template>
    <div class="Mactivity">
        <h2>活动印花</h2>
        <div class="pic" v-for="item in picList" :key="item.activityImgId" @click="jumpPicDetail(item.activityImgId)">
            <div class="imgBox">
                <img :src="url+item.companyNewsImg" alt="">
            </div>
            <p>{{item.title}}</p>
        </div>
    </div>
</template>

<script>
    import { activityGetPageList } from "../../api/api.js";
    export default {
        name: 'Mactivity',
        created() {
            activityGetPageList().then(res => {
                this.picList = res.data.data.list;
                for (let i = 0; i < this.picList.length; i++) {
                    if (this.picList[i].companyNewsImg != null) {
                        this.picList[i].companyNewsImg = this.picList[i].companyNewsImg.split(',')[0]
                    }
                }
            });

        },
        data() {
            return {
                picList: [],
                url: this.GLOBAL.picURL,
            }
        },
        methods: {
            jumpPicDetail(id) {
                this.$router.push({ path: '/MpicDetail', query: { id: id } });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .Mactivity {
        background-color: #f5f5f5;

        h2 {
            text-align: center;
            padding: 4% 0;
            color: #2e324f;
        }
    }

    .pic {
        display: inline-block;
        margin: 4% 2%;
        background-color: #ffffff;

        .imgBox {
            height: 34.285714rem;

            img {
                width: 100%;
                height: 100%;
            }
        }

        p {
            padding: 2% 4%;
            font-size: 16px;
            font-weight: 900;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/mobile/Mactivity.vue